module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "title-data"
  }, [_c('p', [_vm._v("提示：本页面提供的数据仅供商户作为调整经营策略参考，不作为结款与验证的准确依据。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbe6b3da","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/title/Title.vue
// module id = 628
// module chunks = 0